import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { HardHat, Loader2, MailCheck, ArrowLeft } from "lucide-react";
import api, { apiErr } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen dark bg-background text-foreground grid place-items-center p-6">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2 mb-8">
          <div className="h-9 w-9 rounded-lg bg-primary grid place-items-center"><HardHat className="h-5 w-5 text-primary-foreground" /></div>
          <div className="font-extrabold tracking-tight text-lg">SmartBuild <span className="text-primary">AI</span></div>
        </div>

        {sent ? (
          <div className="text-center" data-testid="forgot-sent">
            <div className="h-12 w-12 rounded-full bg-emerald-500/15 grid place-items-center mx-auto mb-4"><MailCheck className="h-6 w-6 text-emerald-500" /></div>
            <h1 className="text-2xl font-bold tracking-tight mb-2">Check your inbox</h1>
            <p className="text-sm text-muted-foreground mb-6">If an account exists for <span className="text-foreground font-medium">{email}</span>, we've sent a link to reset your password. It expires in 1 hour.</p>
            <Link to="/login" className="inline-flex items-center gap-1.5 text-sm text-primary font-semibold hover:underline"><ArrowLeft className="h-4 w-4" />Back to sign in</Link>
          </div>
        ) : (
          <form onSubmit={submit} data-testid="forgot-form">
            <h1 className="text-2xl font-bold tracking-tight mb-1">Forgot password?</h1>
            <p className="text-sm text-muted-foreground mb-6">Enter your email and we'll send you a reset link.</p>
            <label className="block text-sm font-semibold mb-1.5">Email</label>
            <input data-testid="forgot-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full rounded-lg border border-input bg-card px-3 py-2.5 mb-6 outline-none focus:border-primary focus:ring-2 focus:ring-primary/30 transition" placeholder="you@company.com" />
            <button data-testid="forgot-submit-btn" disabled={loading}
              className="w-full rounded-lg bg-primary text-primary-foreground py-2.5 font-bold hover:bg-orange-600 active:bg-orange-700 transition-colors disabled:opacity-60 flex items-center justify-center gap-2">
              {loading && <Loader2 className="h-4 w-4 animate-spin" />} Send reset link
            </button>
            <p className="text-sm text-muted-foreground mt-5 text-center">
              <Link to="/login" className="text-primary font-semibold hover:underline" data-testid="back-to-login-link">Back to sign in</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
